import Parse from "parse";

export interface SIV_MasterDataAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  code: string;
  data: any;
  dataType: string;
}

export class SIV_MasterData extends Parse.Object<SIV_MasterDataAttributes> {
  static className: string = "SIV_MasterData";

  constructor(data?: Partial<SIV_MasterDataAttributes>) {
    super("SIV_MasterData", data as SIV_MasterDataAttributes);
  }

  get code(): string {
    return super.get("code");
  }
  set code(value: string) {
    super.set("code", value);
  }

  get data(): any {
    return super.get("data");
  }
  set data(value: any) {
    super.set("data", value);
  }

  get dataType(): string {
    return super.get("dataType");
  }
  set dataType(value: string) {
    super.set("dataType", value);
  }
}

Parse.Object.registerSubclass("SIV_MasterData", SIV_MasterData);
